import React from 'react';
import { BiMessageAdd } from 'react-icons/bi';
import { Avatar } from '@mui/material';
import { getUserNameById, stringAvatar } from 'src/utils/utils';
import {
  ChatBubble,
  ChatBubbleContainer,
  ChatBubbleRow,
  DateTimeContainer,
  Delete,
  EmptyChatContainer,
  TextContainer,
  TimeContainer,
} from './Chat.styles';
import dayjs from 'dayjs';
import { CommentProps } from '../dashboard-actions/types';
import { FaTimes } from 'react-icons/fa';

interface UserProps {
  id: string;
  name: string;
  firstName: string;
}

interface MessageListProps {
  isLoading: boolean;
  messages: CommentProps[];
  user: UserProps;
  deleteMessage: (messageID: string | number) => void;
}

const MessageList: React.FC<MessageListProps> = ({ isLoading, messages, user, deleteMessage }) => {
  let chatContent = (
    <div className='loading-messages-container'>
      <span className='loading-text'>Loading Messages</span>
    </div>
  );

  if (!isLoading && !messages.length) {
    chatContent = (
      <EmptyChatContainer>
        <BiMessageAdd />
        <span>
          Cet espace est dédié à la <b>collaboration entre les membres de votre équipe</b> sur cette tâche.
        </span>
        <span>
          Veuillez noter que <b>votre juriste ne recevra pas les messages</b> postés ici.
        </span>
      </EmptyChatContainer>
    );
  } else if (!isLoading && messages.length) {
    chatContent = (
      <>
        {messages.map(message => {
          let isUser = user.id === message.sender.id;
          let renderName;
          if (isUser) {
            renderName = null;
          } else {
            renderName = <div className='sender-name'>{message.sender.name}</div>;
          }
          return (
            <ChatBubbleRow key={message._id} isUser={isUser}>
              <Avatar {...stringAvatar(getUserNameById(message.sender.id).toLocaleUpperCase())} />
              <ChatBubbleContainer>
                <ChatBubble isUser={isUser}>
                  {renderName}
                  <TextContainer isUser={isUser}>{message.text}</TextContainer>
                </ChatBubble>
                <TimeContainer isUser={isUser}>
                  <DateTimeContainer>
                    Envoyer le {dayjs(message.time).format('DD/MM HH:mm')} Par {message.sender.name}
                  </DateTimeContainer>
                </TimeContainer>
                {isUser && (
                  <Delete isUser={isUser} onClick={() => deleteMessage(message._id)}>
                    <FaTimes />
                  </Delete>
                )}
              </ChatBubbleContainer>
            </ChatBubbleRow>
          );
        })}
      </>
    );
  }
  return chatContent;
};

export default MessageList;
